/** Match roster side: backend uses 1 = red, 2 = blue. */
export enum TeamId {
  Red = 1,
  Blue = 2,
}

export const MIN_PLAYERS_FOR_TEAM_GENERATION = 2;
